import React from 'react';
import { Segment, Header, Button, Container, Grid, Message, Icon, Input } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';

import styleDef from './style.js';
const style = {
    ...styleDef,
    input: {
        paddingBottom: '40px',
        width: '220px',
    },
}


const NumericInput = ({challenge, 
                       onComplete,
                       onSubmit,
                       value,
                       valid,
                       onChange,
                       placeholder,
                       buttonText,
                       completePending}) => (
    <Container style={style.container}>
        <form style={style.containerDiv} onSubmit={onSubmit}>
            <Segment style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <Grid.Row verticalAlign='top' style={style.topRow}>
                        <Grid.Column verticalAlign='top'>
                            <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>
                            <Instructions challenge={challenge} />

                            <Input 
                                style={style.input}
                                name='value' 
                                value={value} 
                                onChange={onChange} 
                                type='number'
                                placeholder={placeholder}
                              />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
            <div style={{...style.button, ...(valid ? {} : style.buttonDisabled)}} onClick={onComplete}>{buttonText}</div>
        </form>
    </Container>
);

export default NumericInput;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/NumericInput.js